// @ts-check

import { Trigger } from './Trigger'

/**
 * @typedef {Object} ScrollToElementTriggerOptions
 * @property {string} selector css selector of element to listen for clicks
 */

class ScrollToElementTrigger extends Trigger {
  /** @type {IntersectionObserver} */
  observer

  /** @type {string} */
  selector

  /**
   *
   * @param {ScrollToElementTriggerOptions} options
   */
  constructor({ selector }) {
    super()
    this.selector = selector

    /** @type {IntersectionObserverCallback} */
    this.observerCallback = (entries) => {
      if (entries.filter((entry) => entry.isIntersecting).length > 0) {
        this._dispatch()
        this.destroy()
      }
    }

    const element = this._getSelectedNode()
    if (!element)
      throw new Error(`Could not find element with selector "${selector}"`)

    this.observer = new IntersectionObserver(this.observerCallback)
    this.observer.observe(element)
  }

  _getSelectedNode() {
    return document.querySelector(this.selector)
  }

  destroy() {
    if (this.observer) this.observer.disconnect()
    super.destroy()
  }
}

export { ScrollToElementTrigger }
